import React, { useEffect, useState } from 'react';

const PanoContext = React.createContext({ })
export { PanoContext };

const PanoContextContainer = (props) => {
  const [ selected, setSelected ] = useState(0);
  const [enableScroll,setEnableScroll] = useState(false)
  const [ showLoader, setShowLoader ] = useState(true);
  const [ showIntrudction, setShowIntrudction ] = useState(false);
  const [ overlayVisible, setOverlayVisible ] = useState(true);
  const [ hotspotsOutOfView, setHotspotsOutOfView ] = useState(0);
  const [ totalHotspotsInScene, setTotalHotspotsInScene ] = useState(0);
  useEffect(()=>{
  })

  return (
    <PanoContext.Provider
      value={{
        showLoader,
        setShowLoader,
        showIntrudction, 
        setShowIntrudction,
        overlayVisible,
        setOverlayVisible,
        selected,
        setSelected,
        enableScroll,
        setEnableScroll,
        hotspotsOutOfView,
        setHotspotsOutOfView,
        totalHotspotsInScene,
        setTotalHotspotsInScene,
      }}
    >
      { props.children }
    </PanoContext.Provider>
  )
}

export default PanoContextContainer;
